import { checarSessaoAtiva, getDataUserSso } from './auth';
import {
  getTituloNivelInsuficienteGovbr,
  GovbrNivel,
  podeAssinarComGovbr,
} from '../utils/govbrNivelAssinatura';
import { getSsoAccessToken, getSsoTokenValidationMessage } from '../utils/ssoToken';

export type AssinaturaElegibilidadeMotivo = 'session' | 'nivel' | 'error';

export type AssinaturaElegibilidadeResult =
  | { ok: true }
  | { ok: false; reason: 'session'; message: string }
  | { ok: false; reason: 'nivel'; titulo: string; niveis: GovbrNivel[] }
  | { ok: false; reason: 'error'; message: string };

export type AssinaturaElegibilidadeFailure = Extract<
  AssinaturaElegibilidadeResult,
  { ok: false }
>;

export function isAssinaturaElegibilidadeFailure(
  result: AssinaturaElegibilidadeResult,
): result is AssinaturaElegibilidadeFailure {
  return result.ok === false;
}

export async function validarElegibilidadeAssinaturaGovbr(): Promise<AssinaturaElegibilidadeResult> {
  const token = getSsoAccessToken().trim();
  const localSessionMessage = getSsoTokenValidationMessage();

  if (localSessionMessage) {
    return {
      ok: false,
      reason: 'session',
      message: localSessionMessage,
    };
  }

  try {
    const { data: checarData } = await checarSessaoAtiva(token);
    if (!checarData.logado) {
      return {
        ok: false,
        reason: 'session',
        message:
          'Sua sessão expirou ou foi encerrada. Faça login novamente para assinar.',
      };
    }

    const { data: userData } = await getDataUserSso(token);
    const pessoa = Array.isArray(userData) ? userData[0] : userData;

    if (!podeAssinarComGovbr(pessoa?.govbr_niveis)) {
      const niveis = Array.isArray(pessoa?.govbr_niveis)
        ? pessoa.govbr_niveis
        : pessoa?.govbr_niveis
          ? [pessoa.govbr_niveis]
          : [];

      return {
        ok: false,
        reason: 'nivel',
        titulo: getTituloNivelInsuficienteGovbr(pessoa?.govbr_niveis),
        niveis,
      };
    }

    return { ok: true };
  } catch {
    return {
      ok: false,
      reason: 'error',
      message:
        'Não foi possível verificar sua elegibilidade para assinatura. Tente novamente.',
    };
  }
}
